import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What types of work do you take on?",
  answer: "We handle remodelling, tiling, painting, vinyl, laminate and hardwood flooring, plumbing, power washing, carpentry, drywall repair and installation, and snow removal. If your project involves something outside this list, give us a call to see if we can help."
}, {
  question: "How does booking a visit work?",
  answer: "Send your project details through the form on this page or call us directly. We will get back to you within 24 hours to set up a time to walk the site, review what needs to be done, and put together a clear estimate."
}, {
  question: "Are you licensed and insured?",
  answer: "Yes, Ablaze Contracting Service LLC is licensed and insured for contracting work in Virginia."
}, {
  question: "Can I see photos of previous work?",
  answer: "Yes. Our Project Gallery page features completed jobs across flooring, carpentry, painting, and remodelling, alongside customer reviews."
}, {
  question: "How long will my project take?",
  answer: "Timelines depend on the room size, materials, and scope of work. During our site walkthrough we will look at the job and give you an estimated timeframe before any work starts."
}];
export default function CommonQuestions() {
  return <section data-section-id="222313" id="common-questions" className="w-full bg-background text-foreground py-14 md:py-20 lg:py-24">
      <div className="container mx-auto w-full max-w-4xl px-4 md:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-8 md:mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-serif font-normal text-foreground">
            Common questions
          </h2>
          <p className="text-base text-muted-foreground mt-2 max-w-2xl">
            Quick answers about scheduling, services, and how we handle projects.
          </p>
        </div>

        {/* Accordion container */}
        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="bg-card border border-border rounded px-5 py-0.5 transition-colors">
              <AccordionTrigger className="text-foreground font-serif font-normal text-base md:text-lg hover:no-underline hover:text-primary transition-colors text-left py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-4 pt-1 border-t border-border">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}